import React from "react";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import {Dialog, DialogContent} from "@mui/material";

import './RegistrationSuccessPopUp.style.scss';
import {FormattedMessage} from "react-intl";
const RegistrationSuccessPopUp = ({id, title, subTitle, open, onClose, onCancel, onOk, options}) => {


    return (
        <Dialog open={open} onClose={onClose} className="RegistrationSuccessPopUp">
            <DialogContent className="RegistrationSuccessContent">
                <div className={"closeButton"} onClick={onClose}>X</div>
                <Typography className="title">
                    <FormattedMessage id={'popUp.registrationSuccess.title'}/>
                </Typography>
                <div className={'actionButton'}>
                    <Button className="login" onClick={() => {
                        onOk()
                    }}>
                        <FormattedMessage id={'popUp.registrationSuccess.letsPlay'}/>
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
}

export default RegistrationSuccessPopUp;
